<template>
  <el-dialog
    class="modal"
    title="Change password"
    :visible="visible"
    :close-on-click-modal="false"
    @close="$emit('close', false)"
    width="500px">
    <div class="dialog-title" slot="title">
      <i class="iconfont icon-mima"></i>
      {{ $t('changePassword') }}
    </div>
    <div class="password-main">
      <el-input
        :placeholder="$t('currentPassword')"
        :type="oldPwdVisible ? 'input' : 'password'"
        v-model="oldPwd">
        <i slot="suffix"
          class="iconfont"
          @click="oldPwdVisible = !oldPwdVisible"
          :class="oldPwdVisible ? 'iconchakan' : 'iconbiyan'">
        </i>
      </el-input>
      <el-input
        :placeholder="$t('newPassword')"
        :type="newPwdVisible ? 'input' : 'password'"
        v-model="newPwd">
        <i slot="suffix"
          class="iconfont"
          @click="newPwdVisible = !newPwdVisible"
          :class="newPwdVisible ? 'iconchakan' : 'iconbiyan'">
        </i>
      </el-input>
      <el-input
        :placeholder="$t('confirmNewPassword')"
        :type="confirmPwdVisible ? 'input' : 'password'"
        v-model="confirmPwd">
        <i slot="suffix"
          class="iconfont"
          @click="confirmPwdVisible = !confirmPwdVisible"
          :class="confirmPwdVisible ? 'iconchakan' : 'iconbiyan'">
        </i>
      </el-input>
      <div class="btn-wrap">
        <el-button class="gray-btn cancel-btn" @click="$emit('close', false)">{{ $t('cancel') }}</el-button>
        <el-button class="blue-btn save-btn" :loading="loading" @click="handleSave">{{ $t('save') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { changePassword } from '../../api/user'
import config from '../../common/config'
// import { clearApplication } from '../../utils/tool'

export default {
  name: 'ChangePassword',
  props: {
    visible: Boolean
  },
  data () {
    return {
      oldPwd: '',
      newPwd: '',
      confirmPwd: '',
      oldPwdVisible: false,
      newPwdVisible: false,
      confirmPwdVisible: false,
      loading: false
    }
  },
  watch: {
    visible () {
      if (!this.visible) {
        this.resetData()
      }
    }
  },
  methods: {
    handleSave () {
      if (!this.oldPwd) {
        this.$message.error(this.$t('checkCurrentPwd'))
        return
      }
      if (!this.newPwd) {
        this.$message.error(this.$t('checkNewPwd'))
        return
      }
      if (this.newPwd === this.oldPwd) {
        this.$message.error(this.$t('currentNewPasswordCheck'))
        return
      }
      if (!this.confirmPwd) {
        this.$message.error(this.$t('checkConfirm'))
        return
      }
      if (this.newPwd !== this.confirmPwd) {
        this.$message.error(this.$t('checkConfirmSame'))
        return
      }
      const params = {
        newPassword: this.newPwd,
        oldPassword: this.oldPwd
      }
      this.loading = true
      changePassword(params).then(res => {
        this.loading = false
        config.clearUserData()
        this.$message.success(this.$t('changePwdSuccess'))
        setTimeout(() => {
          this.$router.push({ path: '/' })
        }, 2000)
      }).catch(() => {
        this.loading = false
      })
    },
    resetData () {
      this.oldPwd = ''
      this.newPwd = ''
      this.confirmPwd = ''
      this.oldPwdVisible = false
      this.newPwdVisible = false
      this.confirmPwdVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.password-main {
  padding: 20px 95px;
  i {
    line-height: 32px;
    .f-s-12();
    position: absolute;
    right: 0;
    z-index: 1111;
    cursor: pointer;
  }
  .iconbiyan {
    .f-s-18();
    position: relative;
    top: -1px;
    left: -1px;
  }
  .el-input {
    margin: 10px 0;
  }
  .btn-wrap {
    text-align: center;
    .el-button {
      margin: 40px 15px 0;
    }
    .cancel-btn {
      background-color: @color-primary;
    }
  }
}
</style>
